import { DisplayTrixContent } from "@circle-react-uikit/DisplayTrixContent";
import { SeeMoreLess } from "@circle-react-uikit/SeeMoreLess";
import { TipTapBlockEditor } from "@circle-react-uikit/TipTapBlockEditor";

import { DISABLED_EDITOR_EXTENSIONS } from "@/react/components/CommentsCompass/constants";
import { isTiptapComment } from "@/react/components/CommentsCompass/helpers";
import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";
import type { Comment } from "@/react/types/Comment";

import styles from "@/react/components/CommentsCompass/trix.module.css";

interface BodyProps {
  comment: Comment;
}

export const Body = ({ comment }: BodyProps) => {
  const { body_trix_content: bodyTrixContent, tiptap_body: tiptapBody } =
    comment;

  return (
    <div
      data-testid="comment-body"
      {...cssAnchorProps({ anchor: "comment-body" })}
    >
      <SeeMoreLess seeMoreClassName="text-sm" lines={8}>
        {isTiptapComment(comment) ? (
          <TipTapBlockEditor
            readOnly
            shouldRefetch
            value={tiptapBody.body}
            sgidToObjectMap={tiptapBody.sgids_to_object_map}
            inlineAttachments={tiptapBody.inline_attachments}
            openInternalLinksInCurrentTab
            disabledExtensions={DISABLED_EDITOR_EXTENSIONS}
            shouldSupportTables
            variant="compact"
          />
        ) : (
          <div className={styles.displayWrapper}>
            <DisplayTrixContent content={bodyTrixContent} />
          </div>
        )}
      </SeeMoreLess>
    </div>
  );
};
